import React, { useEffect, useState, useContext } from "react";
import DoctorChatBox from "../chat/chatBox";
import Navbar from "../header";
import Footer from "../footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import api, { API_URL, formatDate, AuthContext, showAlert } from "../util/api";
import PremiumLoader from "../loading";



export default function AppointmentInteractionPage() {

    const { id } = useParams();
    const router = useNavigate();
    const [receiverid, setReceiverID] = useState(0);
    const [loading, setloading] = useState(true);
    const [role, setRole] = useState(" ");
    const [receiver, setReceiver] = useState([]);
    const [appointment, setAppointment] = useState([]);
    const { User } = useContext(AuthContext);






    const [messages, setMessages] = useState([
        { from: "doctor", text: "Hello, good day. How are you feeling today?" },
        { from: "patient", text: "Good day doctor, I feel a bit better now." }
    ]);

    const [newMessage, setNewMessage] = useState("");
    const [typing, setTyping] = useState(false);
    const [showHistory, setShowHistory] = useState(true);

    const [history, setHistory] = useState([

    ]);

    const [selectedHistory, setSelectedHistory] = useState(null);
    const [addHistoryPopup, setAddHistoryPopup] = useState(false);
    const [editingHistoryIndex, setEditingHistoryIndex] = useState(null);
    const [newHistoryTitle, setNewHistoryTitle] = useState("");
    const [newHistoryDetails, setNewHistoryDetails] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [patientRequest, setPatientRequest] = useState("");
    const [attachment, setAttachment] = useState("");
    const [consultationId, setConsultationId] = useState(0);
    const [consultation, setConsultation] = useState(null);

    const [showFullRequest, setShowFullRequest] = useState(false);

    const sendMessage = () => {
        if (!newMessage.trim()) return;
        setMessages([...messages, { from: "patient", text: newMessage }]);
        setNewMessage("");

        setTyping(true);
        setTimeout(() => setTyping(false), 2000);
    };

    const addMedicalHistory = () => {
        if (!newHistoryTitle.trim() || !newHistoryDetails.trim()) return;

        const newEntry = { title: newHistoryTitle, details: newHistoryDetails, attachments };

        if (editingHistoryIndex !== null) {
            const updatedHistory = [...history];
            updatedHistory[editingHistoryIndex] = newEntry;
            setHistory(updatedHistory);
            setEditingHistoryIndex(null);
        } else {
            setHistory([...history, newEntry]);
        }

        setNewHistoryTitle("");
        setNewHistoryDetails("");
        setAttachments([]);
        setAddHistoryPopup(false);
    };



    const checkAppointment = async () => {
        try {
            const response = await api.get(`${API_URL}/check-appointment/${id}`);

            let output = response.data;

            if (response.data.status !== 'success') {
                router("/");

            } else {

                setReceiverID(output.receiver_id);
                setRole(output.role);
                setReceiver(output.receiver);
                setAppointment(output.appointment);
                setPatientRequest(output.appointment.report);
                setAttachment(output.appointment.attachment);
                setHistory(output.medical_history.data);
                setConsultationId(output.consultation_id);
                setConsultation(output.consultation);
                setloading(false);

            }

        } catch (error) {

            alert(error);
            /* console.error("Error fetching doctors:", error); */

        }

    }


    const [showReportPopup, setShowReportPopup] = useState(false);
    const [reportReason, setReportReason] = useState("");
    const [reportComment, setReportComment] = useState("");
    const [reportLoading, setReportLoading] = useState(false);


    const [showCancelPopup, setShowCancelPopup] = useState(false);

    const [cancelComment, setCancelComment] = useState("");
    const [cancelLoading, setCancelLoading] = useState(false);


    const reportReasons = [
        "Doctor was unprofessional",
        "Wrong diagnosis",
        "Prescription issue",
        "Doctor did not respond properly",
        "Late consultation",
        "Other"
    ];

    const submitReport = async () => {
        if (!reportReason) {
            showAlert('error', 'error', "Please select a reason for reporting.");
            return;
        }

        try {
            setReportLoading(true);

            const payload = {
                consultation_id: consultationId,
                appointment_id: appointment.id,
                reason: reportReason,
                comment: reportComment
            };

            const response = await api.post(`${API_URL}/consultation/report`, payload);

            if (response.data.status === "success") {
                showAlert("success", "success", "Report submitted successfully.");
                setShowReportPopup(false);
                setReportReason("");
                setReportComment("");
            } else {
                showAlert("error", "error", response.data.message || "Unable to submit report.");
            }

        } catch (error) {
            showAlert("error", "error", "An error occurred while submitting the report.");
        } finally {
            setReportLoading(false);
        }
    };



    const submitCancel = async () => {
        if (!cancelComment) {
            showAlert('error', 'error', "Please type the reason for canceling.");
            return;
        }

        try {
            setCancelLoading(true);

            const payload = {

                consultation_id: consultationId,
                appointment_id: appointment.id,
                comment: cancelComment
            };

            const response = await api.post(`${API_URL}/consultation/cancel`, payload);

            if (response.data.status === "success") {
                showAlert("success", "success", "Cancel successfully.");
                setShowCancelPopup(false);

                setCancelComment("");

                router("/doctor-dashboard");
            } else {
                showAlert('error', 'error', response.data.message || "Unable to submit report.");
            }

        } catch (error) {
            showAlert('error', 'error', "An error occurred while submitting the report.");
        } finally {
            setCancelLoading(false);
        }
    };



    useEffect(() => {

        checkAppointment();
        //check if  appointment is already paid for or  exist  .  

    }, [])



    return (
        <>
            <Navbar menuColor="red" />
            {!loading ?

                <section >


                    <div style={styles.wrapper}>
                        <style>{`
                    @keyframes fadeUp { 0% {opacity:0; transform:translateY(40px);} 100% {opacity:1; transform:translateY(0);} }
                    @keyframes pop { 0% {transform:scale(0.9); opacity:0;} 100% {transform:scale(1); opacity:1;} }
                    @keyframes typingBlink { 0% { opacity: 0.2; } 100% { opacity: 1; } }
                    @media (max-width: 768px) {
                        .layout { flex-direction: column !important; width: 95% !important; }
                        .left, .right { width: 100% !important; }
                    }
                    `}</style>

                        <div className="layout" style={styles.layout}>
                            {/* LEFT */}
                            <div className="left" style={styles.left}>
                                <div align="left">
                                    <button
                                        onClick={appointment.patient_id === User.id ? () => router("/patient-dashboard") : () => router("/doctor-dashboard")}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#007bff",
                                            cursor: "pointer",
                                            fontSize: 16,
                                            padding: 0,
                                        }}
                                        aria-label="Go back"
                                    >
                                        ← Back
                                    </button>
                                </div>

                                <h2 style={styles.heading}>Appointment Overview</h2>
                                <p>
                                    Created On  : {formatDate(appointment.updated_at)}
                                    <br />
                                    Booked :  {appointment.day}
                                    <br />
                                    Start Time  :   {appointment.starttime}
                                    <br />

                                    End Time  :  {appointment.endtime}

                                </p>




                                <div style={styles.frostCard}>
                                    <h3 style={{ ...styles.cardTitle, textTransform: "capitalize" }}>{role}</h3>
                                    <div style={styles.userRow}>
                                        <img alt="" src={receiver.profilePicture || ""} style={styles.avatar} />
                                        <div>
                                            <p><strong>{receiver.name}</strong></p>
                                            {/*  <p style={styles.subText}>Cardiologist</p> */}
                                        </div>
                                    </div>
                                </div>




                                {/* Patient Request / Symptoms */}
                                <div style={styles.frostCard}>
                                    <h3 style={styles.cardTitle}>Patient Request / Symptoms</h3>
                                    {patientRequest !== null &&
                                        <p style={{ fontSize: "14px", lineHeight: "1.5", color: "#333" }}>
                                            {showFullRequest ? patientRequest : (patientRequest.length > 120 ? patientRequest.slice(0, 120) + "..." : patientRequest)}
                                        </p>
                                    }

                                    {attachment != "" && (

                                        <>
                                            <a href={attachment} target="_blank" rel="noreferrer">View Attachment</a>
                                        </>
                                    )}
                                    {patientRequest !== null && <>

                                        {patientRequest.length > 120 && (
                                            <button
                                                style={styles.readMoreBtn}
                                                onClick={() => setShowFullRequest(!showFullRequest)}
                                            >
                                                {showFullRequest ? "Read less" : "Read more"}
                                            </button>
                                        )}

                                    </>

                                    }



                                </div>

                                {/* Medical History */}


                                {history.length > 0 &&



                                    <div style={styles.frostCard}>
                                        <h3 style={styles.cardTitle}>
                                            Consultation History
                                            <span style={styles.toggleBtn} onClick={() => setShowHistory(!showHistory)}>
                                                {showHistory ? "Hide ▲" : "Show ▼"}
                                            </span>
                                        </h3>

                                        {showHistory && (
                                            <div style={styles.historyBox}>
                                                {history.map((item, index) => (
                                                    <div key={index} style={styles.historyItem}>
                                                        <div onClick={() => setSelectedHistory(item)} style={{ cursor: "pointer" }}>
                                                            {item.diagnosis.primary}
                                                        </div>
                                                        <div style={styles.historyButtons}>
                                                            <Link to={`/consultation/${item.id}`} style={styles.editBtn} >View </Link>

                                                        </div>
                                                    </div>
                                                ))}




                                                <Link style={{ ...styles.addHistoryBtn, textAlign: "center" }} to={`/consultation-history/${appointment.patient_id}`}>

                                                    View All


                                                </Link>


                                            </div>
                                        )}
                                    </div>

                                }




                            </div>

                            {/* RIGHT — CHAT */}
                            <div className="right" style={styles.right}>
                                <h2 style={styles.heading}>Live Consultation Chat</h2>
                             

                               <DoctorChatBox id={receiverid} appointment={appointment}   picture={receiver.profilePicture}   /> 

                                <div>
                                    <br />
                                    {User.id !== appointment.patient_id &&
                                        <>
                                            {consultationId !== 0 &&

                                                <>
                                                    {consultation.status === "REJECTED" &&

                                                        <p style={{ color: "red", fontWeight: "bolder", backgroundColor: "lightyellow" }}
                                                        >
                                                            {/* info the doctor that the consultation has being rejected that the consultation needs to be updated */}
                                                            The patient has rejected your conclusion. Please check the chatbox for details and
                                                            update the consultation prescription/conclusion accordingly.
                                                        </p>

                                                    }

                                                    {consultation.status === "PENDING" &&

                                                        <>

                                                            <p style={{ color: "orange", fontWeight: "bolder", backgroundColor: "lightyellow" }} >
                                                                The consultation is concluded and pending patient acceptance.  The consultation  will be
                                                                automatically accepted after 7 days if no action is taken.

                                                            </p>

                                                        </>

                                                    }


                                                    {consultation.status === "COMPLETED" &&

                                                        <>

                                                            <p style={{ color: "orange", fontWeight: "bolder", backgroundColor: "lightyellow" }} >
                                                                The consultation has been completed and accepted by the patient.

                                                            </p>

                                                            {/* show the rate and the comment of the client  here  */}
                                                            <div>


                                                                <div>
                                                                    <strong>Client Rating:</strong>
                                                                    <div
                                                                        aria-label={`Rating: ${consultation?.patient_rating ?? 0} out of 5`}
                                                                        style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}
                                                                    >
                                                                        {Array.from({ length: 5 }).map((_, i) => {
                                                                            const filled = i < Math.round(consultation?.patient_rating ?? 0);
                                                                            return (
                                                                                <span
                                                                                    key={i}
                                                                                    style={{
                                                                                        color: filled ? "#f5b301" : "#ddd",
                                                                                        fontSize: 20,
                                                                                        lineHeight: 1,
                                                                                    }}
                                                                                >
                                                                                    {filled ? "★" : "☆"}
                                                                                </span>
                                                                            );
                                                                        })}
                                                                        <span style={{ marginLeft: 8, color: "#333", fontSize: 14 }}>
                                                                            {consultation?.patient_rating != null ? Number(consultation.patient_rating).toFixed(1) : "No rating"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <strong>Client Comment:</strong> <br /> {consultation.patient_comment}
                                                            </div>

                                                        </>

                                                    }







                                                </>

                                            }


                                            {(appointment.status !== "completed" && appointment.status !== "cancelled") &&
                                                <>

                                                    <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                        to={`/complete_consultation/${id}`} >  {consultationId === 0 ? <> Complete Consultation  </> :
                                                            <> Update Consultation prescription/conclusion </>} </Link>
                                                    &nbsp; &nbsp;

                                                </>

                                            }



                                        </>

                                    }


                                    {consultationId !== 0 &&

                                        <>

                                            {(consultation.status === "PENDING" && User.id === appointment.patient_id) && <>
                                                <p>
                                                    Your consultation is concluded, you can view the prescriptions and conclusion by clicking the
                                                    button below to accept it or ask the doctor for further information.
                                                </p>

                                            </>}

                                            <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                to={`/consultation/${consultationId}`} > Consultation Prescriptions/Conclusion  </Link>


                                            {(User.id === appointment.patient_id && appointment.status === "completed") &&

                                                <>
                                                    &nbsp;&nbsp;

                                                    <Link style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary"
                                                        to={`/doctor-profile/${appointment.doctor_id}`} > Book Appointment  </Link>


                                                </>

                                            }



                                        </>

                                    }



                                    {appointment.status === "booked" &&
                                        <>

                                            {User.id === appointment.patient_id &&
                                                <>
                                                    &nbsp;  &nbsp;
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => setShowReportPopup(true)}
                                                    >
                                                        Report Consultation
                                                    </button>


                                                </>

                                            }

                                            {User.id !== appointment.patient_id &&


                                                <>


                                                    &nbsp;
                                                    <button onClick={() => setShowCancelPopup(true)}
                                                        style={{ marginBottom: "10px" }} className="btn btn-sm btn-danger">Cancel</button>


                                                </>

                                            }


                                        </>

                                    }

                                    {appointment.status === "cancelled" &&

                                        <>
                                            <p style={{ color: "red", backgroundColor: "yellow" }}>

                                                {appointment.cancel_comment}
                                            </p>
                                        </>
                                    }



                                </div>

                            </div>


                        </div>

                        {/* VIEW HISTORY POPUP */}
                        {selectedHistory && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3>{selectedHistory.title}</h3>
                                    <div style={{ fontSize: "15px", lineHeight: "1.5" }}>{selectedHistory.details}</div>

                                    {selectedHistory.attachments.length > 0 && (
                                        <div style={{ marginTop: "10px" }}>
                                            <strong>Attachments:</strong>
                                            {selectedHistory.attachments.map((file, i) => (
                                                <div key={i} style={{ color: "#0077b6", fontSize: "14px" }}>{file.name}</div>
                                            ))}
                                        </div>
                                    )}

                                    <button style={styles.closePopupBtn} onClick={() => setSelectedHistory(null)}>Close</button>
                                </div>
                            </div>
                        )}

                        {/* ADD HISTORY POPUP */}
                        {addHistoryPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3>{editingHistoryIndex !== null ? "Edit Medical History" : "Add Medical History"}</h3>
                                    <input
                                        style={styles.popupInput}
                                        placeholder="History title"
                                        value={newHistoryTitle}
                                        onChange={e => setNewHistoryTitle(e.target.value)}
                                    />
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Full details"
                                        value={newHistoryDetails}
                                        onChange={e => setNewHistoryDetails(e.target.value)}
                                    />
                                    <input
                                        type="file"
                                        multiple
                                        style={styles.popupInput}
                                        onChange={e => setAttachments([...attachments, ...Array.from(e.target.files)])}
                                    />
                                    {attachments.length > 0 && (
                                        <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "4px" }}>
                                            {attachments.map((file, i) => (
                                                <div key={i} style={{ color: "#0077b6", fontSize: "14px" }}>{file.name}</div>
                                            ))}
                                        </div>
                                    )}

                                    <button style={styles.saveBtn} onClick={addMedicalHistory}>Save</button>
                                    <button style={styles.closePopupBtn} onClick={() => { setAddHistoryPopup(false); setEditingHistoryIndex(null); }}>Cancel</button>
                                </div>
                            </div>
                        )}



                        {/* report popup area  */}
                        {showReportPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3 style={{ color: "#b00000" }}>Report Consultation</h3>

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Select Reason
                                    </label>
                                    <select
                                        style={styles.popupInput}
                                        value={reportReason}
                                        onChange={(e) => setReportReason(e.target.value)}
                                    >
                                        <option value="">-- Select reason --</option>
                                        {reportReasons.map((reason, index) => (
                                            <option key={index} value={reason}>
                                                {reason}
                                            </option>
                                        ))}
                                    </select>

                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Additional Comment (optional)
                                    </label>
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Explain your issue in detail..."
                                        value={reportComment}
                                        onChange={(e) => setReportComment(e.target.value)}
                                    />

                                    <button
                                        style={{
                                            ...styles.saveBtn,
                                            background: "#b00000",
                                            opacity: reportLoading ? 0.6 : 1
                                        }}
                                        onClick={submitReport}
                                        disabled={reportLoading}
                                    >
                                        {reportLoading ? "Submitting..." : "Submit Report"}
                                    </button>

                                    <button
                                        style={styles.closePopupBtn}
                                        onClick={() => setShowReportPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}



                        {/* cancel popup area  */}
                        {showCancelPopup && (
                            <div style={styles.popupOverlay}>
                                <div style={styles.popupCard}>
                                    <h3 style={{ color: "#b00000" }}>Cancel Consultation</h3>



                                    <label style={{ fontSize: 14, fontWeight: "600" }}>
                                        Reason
                                    </label>
                                    <textarea
                                        style={styles.popupTextarea}
                                        placeholder="Explain your issue in detail..."
                                        value={cancelComment}
                                        onChange={(e) => setCancelComment(e.target.value)}
                                    />

                                    <button
                                        style={{
                                            ...styles.saveBtn,
                                            background: "#b00000",
                                            opacity: cancelLoading ? 0.6 : 1
                                        }}
                                        onClick={submitCancel}
                                        disabled={cancelLoading}
                                    >
                                        {cancelLoading ? "Submitting..." : "Submit "}
                                    </button>

                                    <button
                                        style={styles.closePopupBtn}
                                        onClick={() => setShowCancelPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}




                    </div>
                </section>

                :

                <PremiumLoader />


            }

            <Footer />
        </>
    );
}

/* INLINE STYLES */
const styles = {
    wrapper: { width: "100%", minHeight: "100vh", background: "linear-gradient(135deg,#dfefff,#ffffff)", padding: "40px 0", display: "flex", justifyContent: "center" },
    layout: { width: "85%", display: "flex", gap: "30px", animation: "fadeUp 0.8s ease" },
    left: { width: "33%", display: "flex", flexDirection: "column", gap: "20px" },
    right: { width: "67%", display: "flex", flexDirection: "column" },
    heading: { fontSize: "26px", fontWeight: "700", color: "#004d73" },
    frostCard: { padding: "20px", borderRadius: "18px", background: "rgba(255,255,255,0.55)", backdropFilter: "blur(20px)", boxShadow: "0 6px 20px rgba(0,0,0,0.1)", animation: "pop 0.4s ease" },
    cardTitle: { fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#006699", display: "flex", justifyContent: "space-between" },
    toggleBtn: { fontSize: "13px", cursor: "pointer", color: "#005f8a" },
    readMoreBtn: { background: "none", border: "none", color: "#0077b6", cursor: "pointer", fontSize: "13px", padding: "0", marginTop: "5px" },
    userRow: { display: "flex", alignItems: "center", gap: "12px" },
    avatar: { width: "55px", height: "55px", borderRadius: "50%" },
    subText: { fontSize: "13px", color: "#777" },
    historyBox: { marginTop: "10px", display: "flex", flexDirection: "column", gap: "8px" },
    historyItem: { padding: "10px", background: "#eef8ff", borderRadius: "10px", fontSize: "14px", display: "flex", justifyContent: "space-between", alignItems: "center" },
    historyButtons: { display: "flex", gap: "6px" },
    editBtn: { padding: "6px 10px", background: "#0077b6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px" },
    deleteBtn: { padding: "6px 10px", background: "#b00000", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "12px" },
    addHistoryBtn: { marginTop: "12px", padding: "10px", background: "#0077b6", border: "none", color: "white", borderRadius: "10px", cursor: "pointer", fontSize: "14px" },
    videoBtn: { width: "100%", marginTop: "12px", padding: "12px", borderRadius: "12px", background: "#0077b6", color: "white", border: "none", cursor: "pointer", fontSize: "15px" },
    chatArea: { flex: 1, background: "white", borderRadius: "20px", padding: "20px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px", boxShadow: "0 6px 20px rgba(0,0,0,0.1)" },
    msgBubble: { padding: "12px 16px", borderRadius: "16px", maxWidth: "65%", animation: "fadeUp 0.4s ease", fontSize: "14.5px", lineHeight: "1.4" },
    doctorBubble: { background: "#e6f7ff", alignSelf: "flex-start" },
    patientBubble: { background: "#d4ffe0", alignSelf: "flex-end" },
    typingBubble: { background: "#e6f7ff", alignSelf: "flex-start", padding: "10px 15px", borderRadius: "15px", display: "flex", gap: "4px", width: "50px" },
    typingDot: { animation: "typingBlink 0.7s infinite alternate" },
    inputRow: { display: "flex", gap: "12px", marginTop: "15px" },
    input: { flex: 1, padding: "14px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "15px" },
    sendBtn: { padding: "14px 20px", borderRadius: "12px", background: "#0077b6", border: "none", color: "white", cursor: "pointer" },
    floatingButton: { position: "fixed", bottom: "25px", right: "25px", width: "50px", height: "50px", borderRadius: "50%", background: "#0077b6", color: "white", border: "none", fontSize: "24px", cursor: "pointer", boxShadow: "0 6px 18px rgba(0,0,0,0.2)" },
    popupOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.45)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 999 },
    popupCard: { background: "white", width: "400px", padding: "25px", borderRadius: "16px", boxShadow: "0 10px 35px rgba(0,0,0,0.2)", animation: "pop 0.3s ease", display: "flex", flexDirection: "column", gap: "12px" },
    popupInput: { padding: "12px", borderRadius: "10px", border: "1px solid #ccc", fontSize: "14px" },
    popupTextarea: { padding: "12px", borderRadius: "10px", border: "1px solid #ccc", fontSize: "14px", minHeight: "120px", resize: "vertical" },
    saveBtn: { padding: "12px", borderRadius: "12px", background: "#008000", color: "white", fontSize: "15px", border: "none", cursor: "pointer" },
    closePopupBtn: { padding: "10px", borderRadius: "10px", background: "#b00000", color: "white", fontSize: "14px", border: "none", cursor: "pointer" },
};
